import React from 'react'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'

export default function WyborWariantuRZiS({
  dostepneWarianty,
  wariant,
  zmienWariant,
}) {
  return dostepneWarianty && dostepneWarianty.length > 1 ? (
    <RadioGroup
      row
      name="variantRZiS"
      value={dostepneWarianty[wariant]}
      onChange={e => {
        zmienWariant(dostepneWarianty.indexOf(e.target.value))
      }}
    >
      {dostepneWarianty.map(element => (
        <FormControlLabel
          className="wariantRZiS"
          key={element}
          value={element}
          control={<Radio color="primary" />}
          label={element}
        />
      ))}
    </RadioGroup>
  ) : null
}
